import React from 'react';
import PropTypes from 'prop-types';
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import cn from 'classnames';

import * as styles from '../AccordionInner/styles.module.scss';
import Link from '@src/utility/Link';

const ViewFullDetailsLink = ({ url }) => {
  return (
    <>
      <Link
        to={url}
        className="btn btn-secondary btn-secondary--upper btn-secondary--max-width w-full mr-6 mb-6"
        styled={false}
      >
        Apply now
      </Link>
      <a
        className="type-sans-030 inline-link sm-down:inline-block sm-down:mb-6 sm-down:w-fit"
        href={url}
        target="_blank"
      >
        See full detail
      </a>
    </>
  );
};

const CareerItem = ({ uuid, data }) => (
  <AccordionItem id={`${uuid}`} uuid={uuid}>
    <AccordionItemHeading className={styles.accordionHeading}>
      <AccordionItemButton className={styles.accordionButton2}>
        <div className="grid grid-cols-9 items-center gap-x-10">
          <p className="type-sans-530 font-medium col-span-9 sm:col-span-3 py-2 sm:py-6 sm-down:order-1">
            {data.title}
          </p>
          <p className="type-sans-230 text-mono-600 col-span-4 sm:col-span-2 py-2 sm:py-6 sm-down:order-2">
            {data.location.name}{' '}
            <img
              src="/images/icons/location.svg"
              className="inline sm:hidden w-3 align-text-bottom"
            />
          </p>
          <p className="type-sans-230 text-mono-600 col-span-9 sm:col-span-2 py-2 sm:py-6 sm-down:order-4">
            {data.department.name}
          </p>
          <p className="type-sans-230 text-mono-600 col-span-5 sm:col-span-2 py-2 sm:py-6 sm-down:order-3">
            {data.employment_type_text}{' '}
            <img
              src="/images/icons/term.svg"
              className="inline sm:hidden w-4 align-text-bottom"
            />
          </p>
        </div>
      </AccordionItemButton>
    </AccordionItemHeading>
    <AccordionItemPanel className={`${styles.accordionPanel}`}>
      <div className="grid grid-cols-9 sm:gap-10 p-6">
        {/* JD */}
        <div className={`col-span-9 sm:col-span-3 ${styles.jobContent}`}>
          <div
            dangerouslySetInnerHTML={{ __html: data.description }}
            className="mb-6"
          ></div>

          <div className="hidden sm:block">
            <ViewFullDetailsLink url={data.url} />
          </div>
        </div>

        {/* Key responsibilites */}
        <div className={`col-span-9 sm:col-span-6 ${styles.jobContent}`}>
          <strong>{data.key_responsibilities_header}</strong>
          <div
            dangerouslySetInnerHTML={{ __html: data.key_responsibilities }}
            className={styles.listing}
          ></div>
          <br></br>
          <strong>{data.skills_knowledge_expertise_header}</strong>
          <div
            dangerouslySetInnerHTML={{
              __html: data.skills_knowledge_expertise,
            }}
            className={styles.listing}
          ></div>
          <div className="sm:hidden mt-4 flex flex-col-reverse">
            <ViewFullDetailsLink url={data.url} />
          </div>
        </div>
      </div>
    </AccordionItemPanel>
  </AccordionItem>
);

export default CareerItem;
